module.exports = __webpack_public_path__ + "img/840.1d829918.svg";